import React from "react";
import T from "prop-types";
import { displayInt, displayFloat } from "LIB/formatters/number";
import { DataTable } from "MODULES/shared/components";
import { dollars } from "LIB/formatters/currency";
import _ from "lodash";
import { SELLER_ID } from "MODULES/SalesOrders/constants";

const renderRow = (r, pageActions) => (
  <tr key={r.seller}>
    <td
      className="btn btn-link text-left"
      style={{ textTransform: "none", minWidth: 0 }}
      onClick={() => pageActions.setFilter(SELLER_ID, r.seller_id)}
    >
      {r.seller}
    </td>
    <td className="text-center">{dollars(r.total_sales)}</td>
    <td className="text-center">{dollars(r.total_sales_credit)}</td>
    <td className="text-center">{displayInt(r.outgoing_quotes_count)}</td>
    <td className="text-center">{displayInt(r.so_line_items_count)}</td>
    <td className="text-center">{displayFloat(r.oq_to_so_conversion)} %</td>
    <td className="text-center">{displayInt(r.so_lines_shared)}</td>
    <td className="text-center">
      {displayInt(r.total_sales_quantity_cancelled)}
    </td>
  </tr>
);

export default function CurrentSalesTable({ results, isLoading, pageActions }) {
  const report = _.get(results[0], "current");

  return (
    <DataTable loading={isLoading} loadingRows={30}>
      <DataTable.Head>
        <th />
        <th className="text-center">Total as Seller ($)</th>
        <th className="text-center">Seller Credit ($)</th>
        <th className="text-center">#OQs Entered</th>
        <th className="text-center">#SO Line Items </th>
        <th className="text-center">OQ-SO Conversion (%)</th>
        <th className="text-center">#Shared SO&apos;s</th>
        <th className="text-center"># Cancelled SOs</th>
      </DataTable.Head>
      <DataTable.Body>
        {report ? report.map(r => renderRow(r, pageActions)) : []}
      </DataTable.Body>
    </DataTable>
  );
}

CurrentSalesTable.propTypes = {
  isLoading: T.bool.isRequired,
  pageActions: T.shape({}).isRequired,
  results: T.arrayOf(T.shape({})).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/UserStats/CurrentSalesTable.jsx